// extracted by mini-css-extract-plugin
export default {"money":"Money_money__+5DXN","left":"Money_left__IgXMw","btn":"Money_btn__bVf5U"};